import { ViewFile } from '@/components/ats/FileUpload';
import { SanitizedText } from '@/ui/SanitizedDom';
import { Flex } from '@chakra-ui/react';

export const AssessmentDetailsWrapper = ({
  details = '',
  attachments = [],
}) => {
  return (
    <Flex flexDir="column" gap="12px">
      <SanitizedText
        html={details || '-'}
        size="sm-medium"
        color="ats-text-secondary"
        className="editor-style"
      />
      {attachments?.map((item) => (
        <ViewFile key={item.id} file={item} useDirect={true} />
      ))}
    </Flex>
  );
};
